package com.crowpay.views.screens.common

import com.crowpay.views.components.nav.AppDimensions
import com.lightningkite.kiteui.ViewWrapper
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.dialogScreenNavigator
import com.lightningkite.kiteui.navigation.screenNavigator
import com.lightningkite.kiteui.reactive.Property
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.reactive.reactive
import com.lightningkite.kiteui.views.ViewModifiable
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.direct.DismissBackground
import com.lightningkite.kiteui.views.direct.dismissBackground
import com.lightningkite.kiteui.views.direct.scrolls
import com.lightningkite.kiteui.views.direct.stack
import com.lightningkite.kiteui.views.direct.swapView
import com.lightningkite.kiteui.views.direct.swapping
import com.lightningkite.kiteui.views.rContextAddon

val ViewWriter.secondDialog: Property<Page?> by rContextAddon(Property(null))

interface DialogOrPage : Page {
    fun ViewWriter.renderAsDialog(): ViewModifiable
    fun ViewWriter.renderAsPage(): ViewModifiable

    override fun ViewWriter.render2(): ViewModifiable =
        if (screenNavigator === dialogScreenNavigator) renderAsDialog() else renderAsPage()
}

interface DialogWithDialog : Page {
    fun DismissBackground.renderDialog(): ViewModifiable

    fun ViewWriter.dismissSecondDialog() { secondDialog.value = null }

    val dismissScrolls: Boolean get() = false   // TODO: I hate this. Deprecate this interface and find something better.

    override fun ViewWriter.render2(): ViewModifiable {
        secondDialog.value = null
        return (if (dismissScrolls) scrolls else ViewWrapper) - dismissBackground {
            spacing = AppDimensions.fullIndent
            renderDialog()
            swapView {
                swapping(
                    current = { secondDialog() },
                    views = { it?.run { render2() } }
                )
            }
        }
    }
}

interface DialogWithDialogOrPage : DialogWithDialog, DialogOrPage {
    override fun ViewWriter.renderAsDialog(): ViewModifiable {
        secondDialog.value = null
        return dismissBackground {
            renderDialog()
            swapView {
                swapping(
                    current = { secondDialog() },
                    views = { it?.run { render2() } }
                )
            }
        }
    }
    override fun ViewWriter.render2(): ViewModifiable =
        if (screenNavigator === dialogScreenNavigator) renderAsDialog()
        else {
            secondDialog.value = null
            renderAsPage().also {
                it.reactive {
                    secondDialog()?.let(dialogScreenNavigator::navigate)
                }
            }
        }
}